import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageSquare } from "lucide-react";
import { useLang } from "@/hooks/useLang";
import { BUSINESS, UI, trackEvent } from "@/content/site";
import "./mobileStickyBar.css";

export default function MobileStickyBar() {
  const lang = useLang();
  const ui = UI[lang];
  return (
    <div className="gw-mobile-sticky" data-testid="mobile-sticky-bar" role="complementary" aria-label={lang === "en" ? "Quick contact" : "Contacto rápido"}>
      <a
        href={`tel:${BUSINESS.phoneTel}`}
        data-testid="mobile-sticky-call-button"
        className="gw-mobile-sticky-btn gw-mobile-sticky-call"
        onClick={() => trackEvent("phone_click", { location: "mobile_sticky_bar", page: window.location.pathname })}
      >
        <Phone size={18} strokeWidth={2.2} aria-hidden="true" />
        <span>{ui.ctaCallNow}</span>
      </a>
      <Link
        to={ui.contactUrl}
        data-testid="mobile-sticky-consult-button"
        className="gw-mobile-sticky-btn gw-mobile-sticky-consult"
        onClick={() => trackEvent("cta_click", { location: "mobile_sticky_bar", label: "consultation" })}
      >
        <MessageSquare size={18} strokeWidth={2.2} aria-hidden="true" />
        <span>{ui.ctaConsultation}</span>
      </Link>
    </div>
  );
}
